import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NextAction from '../../containers/Widget/NextAction';
import Overlay from '../../containers/Widget/Overlay';
import OverlayPartner from '../../containers/Widget/OverlayPartner';
import OverlayPublisher from '../../containers/Widget/OverlayPublisher';
import WidgetHeader from '../../containers/Widget/WidgetHeader';

import { Footer } from '../../containers/DefaultStyles/Shared';

import {
    Body,
    Container,
    Content as DefaultContent,
    ContentContainer as DefaultContentContainer
} from '../../containers/DefaultStyles/Details';

import ShareDrawer from '../../components/ShareDrawer';
import { Title } from '../../components/Shared/TitleSuccess';

import { widthEm } from '../../utils/size';
import { copyFor } from '../../copy/copy';

const Content = styled(DefaultContent)`
    ${() => (widthEm() <= 30 ? `display: inline;` : ``)};
`;

const ContentContainer = styled(DefaultContentContainer)`
    margin-top: 0;
`;

const Description = styled.div`
    object-fit: contain;
    font-family: Lato;
    line-height: 1.45;
    color: #000;
    ${props => (props.hasDirectionsLink ? 'font-size: 14px;' : 'font-size: 16px;')};

    @media (max-width: 36.5em) {
        ${props => (props.hasDirectionsLink ? 'font-size: 13px;' : 'font-size: 14px;')};
    }

    @media (max-width: 30em) {
        ${props => (props.hasDirectionsLink ? 'font-size: 14px;' : 'font-size: 16px;')};
        line-height: 1.35;
    }
`;

const ThankYouText = styled.span`
    color: #333;

    a {
        color: #ff245e;
        text-decoration: none;
    }
`;

const IframeComponent = styled.div``;

const ConfirmationCard = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body>
            <WidgetHeader />
            <Content>
                {props.fullAddress && (
                    <IframeComponent>{props.iframeComponent}</IframeComponent>
                )}
                <ContentContainer>
                    {props.thankYouTitle ? (
                        <Title>{props.thankYouTitle}</Title>
                    ) : (
                        props.titleComponent
                    )}
                    <Description hasDirectionsLink={props.getDirectionsComponent}>
                        {!props.hideSubtitle &&
                            !props.thankYouText &&
                            (props.useLocalRepresentative ? (
                                <span>
                                    {copyFor(
                                        'endCardFeedback',
                                        'contactRep',
                                        undefined,
                                        undefined,
                                        { peopleCount: props.peopleCount }
                                    )}
                                </span>
                            ) : (
                                <span>
                                    {copyFor(
                                        'endCardFeedback',
                                        'changeHeadlines',
                                        undefined,
                                        undefined,
                                        { peopleCount: props.peopleCount }
                                    )}
                                </span>
                            ))}
                        {props.bodyComponent ? (
                            props.bodyComponent
                        ) : (
                            <ThankYouText
                                dangerouslySetInnerHTML={{ __html: props.thankYouText }}
                            />
                        )}
                    </Description>
                    {props.fullAddress && props.getDirectionsComponent}
                </ContentContainer>
            </Content>
        </Body>
        <Footer>
            <ShareDrawer rightAlign={props.rightAlign} newsletterSignUpVisible={true} />
        </Footer>
        <NextAction />
    </Container>
);

ConfirmationCard.propTypes = {
    peopleCount: PropTypes.string,
    thankYouText: PropTypes.string,
    thankYouTitle: PropTypes.string,
    titleComponent: PropTypes.element.isRequired,
    iframeComponent: PropTypes.element,
    getDirectionsComponent: PropTypes.element,
    fullAddress: PropTypes.string,
    bodyComponent: PropTypes.element,
    useLocalRepresentative: PropTypes.bool,
    hideSubtitle: PropTypes.bool,
    rightAlign: PropTypes.bool
};

export default connect(
    () => ({}),
    {}
)(ConfirmationCard);



// WEBPACK FOOTER //
// ./src/components/Shared/ConfirmationCard.jsx